/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.progress-box[_ngcontent-%COMP%] {\n  position: relative;\n  display: flex;\n  width: 100%;\n  padding-top: 40px; }\n\n.dialog-title[_ngcontent-%COMP%] {\n  padding-left: 20px;\n  padding-top: 14px;\n  color: #5A5A64;\n  font-weight: bold;\n  font-size: 13px; }\n\n.border_radius[_ngcontent-%COMP%] {\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px; }\n\n.complete-label-style[_ngcontent-%COMP%] {\n  font-size: 20px; }'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9zcmMvYXBwL21vZGFscy9tb2RhbC1sb2FkaW5nLmNvbXBvbmVudC5zY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3NyYy91aS9zcmMvYXBwL21vZGFscy9tb2RhbC1sb2FkaW5nLmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// ./aot_output/src/app/modals/modal-loading.component.scss.shim.ngstyle.ts